import { BehaviorSubject, Observable } from 'rxjs';

import { ScheduledJob } from '@shure/cloud/shared/models/devices';

export abstract class ScheduledJobsApiService {
	public abstract scheduledJobs: BehaviorSubject<ScheduledJob[]>;
	public abstract scheduledJobs$(): Observable<ScheduledJob[]>;
	public abstract scheduledJobsCount$(): Observable<number>;
	public abstract loadingInProgress$(): Observable<boolean>;

	public abstract refresh(): void;
}
